import { render, staticRenderFns } from "./TestPage.vue?vue&type=template&id=9fff80fc&"
import script from "./TestPage.vue?vue&type=script&lang=js&"
export * from "./TestPage.vue?vue&type=script&lang=js&"
import style0 from "./TestPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports